import { Component, Input, EventEmitter, Output, AfterViewInit, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { ImgBookHelperService } from '../../../services/img-book-helper.service';
import { XAPIHelperService } from '../../../services/xAPI-helper.service';
import { LoaderService } from '../../../../app/services/loader.service';
import { environment } from 'environments/environment';
import { NetwordDetectionService } from 'modules/app/services/network-detection.service';
import { Subscription } from 'rxjs';
import { DownloadHelperService } from 'modules/desktop/services/download-helper.service';
import { AuthService } from '../../../../app/services/auth.service';
import {TabbingOrderService} from '../../../services/tabbing-order.service';
import { ResourceBankHelperService } from 'modules/app/services/resource-bank-helper.service';

declare var $:any;

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.template.html',
  styleUrls: ['./toolbar.style.scss'],
  animations: [
    trigger(
      'inOutAnimation', 
      [
        transition(
          ':enter', 
          [
            style({opacity: 0}),
            animate('0.55s ease-out', style({opacity: 1})) 
          ]
        )        
      ]
    )
  ]
})
export class Toolbar implements AfterViewInit, OnInit, OnDestroy{
  @Input() 
  set inputConfig(incomingConfig: any) {
    Object.assign(this.config, incomingConfig);
  }
  @Input() ebookData;
  @Input() currentBook;
  @Input() toolButtonOfflineState;
  @Input() dictionaryAvailable;
  @Input() showNotesTooltip: boolean = false;
  @Output("toggleTimer") toggleTimer: EventEmitter<any> = new EventEmitter();
  @Output("navigateToUserDashboard") navigateToUserDashboard: EventEmitter<any> = new EventEmitter();
  @Output("switch") switch: EventEmitter<any> = new EventEmitter();
  @Output("jumpToPagePanelEventHandler") jumpToPagePanelEventHandler: EventEmitter<any> = new EventEmitter();
  @Output("toggleTools") toggleTools: EventEmitter<any> = new EventEmitter();
  @Output("toggleDrawingMenu") toggleDrawingMenu : EventEmitter<any> = new EventEmitter();
  @Output("toggleMobileTools") toggleMobileTools : EventEmitter<any> = new EventEmitter();
  @Output("toggleSelectionBoxMenu") toggleSelectionBoxMenu: EventEmitter<any> = new EventEmitter();
  @Output("lastVisitedPage") lastVisitedPage: EventEmitter<any> = new EventEmitter();
  @Output("toggleSidebar") toggleSidebar: EventEmitter<any> = new EventEmitter();
  @Output("fitToWidth") fitToWidth: EventEmitter<any> = new EventEmitter();
  @Output("fitToScreen") fitToScreen: EventEmitter<any> = new EventEmitter();
  @Output("selectionDelete") selectionDelete: EventEmitter<any> = new EventEmitter();
  @Output("openMenu") openMenu: EventEmitter<any> = new EventEmitter();
  @Output("closeMenu") closeMenu: EventEmitter<any> = new EventEmitter();
  @Output("toggleSubMenu") toggleSubMenu: EventEmitter<any> = new EventEmitter();
  @Output("setCurrentTool") setCurrentTool: EventEmitter<any> = new EventEmitter();
  @Output("nextPage") nextPage: EventEmitter<any> = new EventEmitter();
  @Output("previousPage") previousPage: EventEmitter<any> = new EventEmitter();
  @Output("zoomPage") zoomPage: EventEmitter<any> = new EventEmitter();
  @Output("selectionMask") selectionMask: EventEmitter<any> = new EventEmitter();
  @Output("toggleImgbookLayout") toggleImgbookLayout: EventEmitter<any> = new EventEmitter();
  @Output("selectionSpotlight") selectionSpotlight: EventEmitter<any> = new EventEmitter();
  @Output("hideAll") hideAll: EventEmitter<any> = new EventEmitter();
  @Output("undo") undo: EventEmitter<any> = new EventEmitter();
  @Output("redo") redo: EventEmitter<any> = new EventEmitter();
  @Output("toggleNotesWrapper") toggleNotesWrapper: EventEmitter<any> = new EventEmitter();
  @Output("toggleNotesWrapperMobile") toggleNotesWrapperMobile: EventEmitter<any> = new EventEmitter();
  @Output("addNote") addNote: EventEmitter<any> = new EventEmitter();
  @Output("toggleBook") toggleBook: EventEmitter<any> = new EventEmitter();
  @Output("openResourceBank") openResourceBank: EventEmitter<any> = new EventEmitter();

  config:any = {
    "current-menu" : null, // null, "MAIN_MENU", "PEN_MENU", "HIGHLIGHTER_MENU", "PAGE_VIEW"
    "current-sub-menu" : null, // null, "PEN_SUB_MENU_COLOR", "PEN_SUB_MENU_WIDTH", "HIGHLIGHTER_SUB_MENU_COLOR", "HIGHLIGHTER_SUB_MENU_WIDTH", "PAGE_VIEW_ZOOM"
    "position" : "left", //  "left", "right"
    "menus": {
      "MAIN_MENU": {
        "menu-items": {
          "sidebar": {
            "visible": true
          },
          "pen": {
            "visible": true
          },
          "highlighter": {
            "visible": true
          },
          "page-view": {
            "visible": true
          },
          "delete": {
            "visible": true
          },
          "timer": {
            "visible": true
          },
          "notes": {
            "visible": true
          }
        }
      },
      "PEN_MENU": {
        "menu-items": {
          "previous-menu": {
            "visible": true
          },
          "color": {
            "visible": true,
            "stroke-color": ["#000000", "#0002FF", "#B90000", "#00B32E"]
          },
          "width": {
            "visible": true,
            "stroke-size": ["2px", "6px", "10px", "14px"]
          },
          "undo": {
            "visible": true
          },
          "redo": {
            "visible": true
          },
          "hide": {
            "visible": true
          }
        },
        "value" : {
            "stroke-color" : "#000000",
            "stroke-size" : "6px"
        }
      },
      "HIGHLIGHTER_MENU": {
        "menu-items": {
          "previous-menu": {
            "visible": true
          },
          "color": {
            "visible": true,
            "stroke-color": ["#FFFF00", "#75F8F8", "#F878F8", "#78F878"]
          },
          "width": {
            "visible": true,
            "stroke-size": ["4px", "16px", "20px", "24px"]
          },
          "eraser": {
            "visible": true
          },
          "delete": {
            "visible": true
          },
          "hide": {
            "visible": true
          }
        },
        "value" : {
          "stroke-size": "16px",
          "stroke-color": "#FFFF00"
        }
      },
      "PAGE_VIEW": {
        "menu-items": {
          "previous-menu": {
            "visible": true
          },
          "zoom": {
            "visible": true
          },
          "fit-to-width": {
            "visible": true
          },
          "fit-to-screen": {
            "visible": true
          },
          "single-double-page-view": {
            "visible": true
          },
          "spotlight": {
            "visible": true
          },
          "mask": {
            "visible": true
          }
        }
      }
    }
  }

  isPanelOpen:any = false; // variable to control jump to page panel
  panelOnSamePage:any = false; // flag to check error for jump to page panel,
  jumpToString:any = ""; // string to store the page number to jump to
  totalPages:any = "";
  panelError:any = false; // to store if there is some error in jump string
  pageDoesNotExistError:any = false; // to store if the page entered via jump to page panel exists or not
  firstCurrentPage:any = "";
  secondCurrentPage:any = "";
  jumpToPageHandler:any;
  goDisabled:any = false;
  isDrawingLoaded:any = false;
  isPageLoaded:any = false;
  lastActiveFeature:any = "spotlight";
  isDesktop:boolean = false;
  isTeacher:boolean = false;
  isPageLength:boolean = false;
  userData:any;

  // flag to store whether the system is online or offline
  // needed when book is launched in desktop app
  isOnline: boolean = false;
  networkStatusSubscription: Subscription;
  isAnyBookDownloaded: boolean = false;
  public imageBasePath: string = IMAGES_BASEPATH;

  // flag to show resource bank button
  showResourceBankButton: boolean = false;

  constructor(
    private ref: ChangeDetectorRef,
    private imgBookHelperService: ImgBookHelperService,
    private xAPIHelperService: XAPIHelperService,
    private loaderService: LoaderService,
    private networkService: NetwordDetectionService,
    private downloadHelperService: DownloadHelperService,
    public authService: AuthService,
    public tabbingOrderService: TabbingOrderService,
    private readonly resourceBankHelperService: ResourceBankHelperService
  ) {
    this.jumpToPageHandler = this.jumpToPagePanelKeyboardEventListenerHandler.bind(this);
  }


  ngOnInit(): void {
    this.networkService.isOnline(true).then(result => (this.isOnline = result));
    this.networkStatusSubscription = this.networkService.monitorStatus().subscribe(async (isOnline) => {
      if (this.isOnline != isOnline) {
        this.isOnline = isOnline;
      }
    });
    this.isAnyBookDownloaded = this.anyBookDownloaded();
    this.isDesktop = environment.isDesktopApp;
    this.isTeacher = ["admin", "teacher"].indexOf(this.authService.getUserData().role) !== -1 ? true : false;
    this.userData = this.authService.getUserData();
  }

  ngAfterViewInit() {
    let that = this;
    // prevent closing of dropdown using event delegation.
    $(".foc-container").on('hide.bs.dropdown', '#jump-to-page-panel-toolbar', function (event) {

      // detect event changes from student book
      that.ref.detectChanges();
 
      // if the event was triggered by student book then return
      if(event.closeDropdownKeyboard) {
        return;
      }

      // if the event was any other event that closes the dropdown then prevent that.
      if(!event.closeDropdownKeyboard && that.isPanelOpen) {
        event.preventDefault();
        return; 
      }

    });

    // escape key opens dropdown when closed. IDK why this was occuring but it was something on the bootstraps part. was present on higher environment also.
    $('#jump-to-page-panel-toolbar').on('keydown', function(event) {


      // if panel was closed and escape was pressed then do not propogate the event
      if(!that.isPanelOpen && event.keyCode == 27) {
        event.stopPropagation();
      }

    });

    $(".foc-container").on('hide.bs.dropdown', '#jump-to-page-panel', function (event) {
      if(that.isPanelOpen) return event.preventDefault();
    });

    $('.zoom-dropdown').on('show.bs.dropdown', function () {
      $('.notes-wrapper').css("z-index", 0);
    })

    $('.zoom-dropdown').on('hide.bs.dropdown', function () {
      $('.notes-wrapper').css("z-index", 1999);
    })

    this.showResourceBankButton = this.resourceBankHelperService.showResourceBankButton();

    // NEMO-7805: Open Sidebar on page refresh and fit to width
    // NEMO-10739: Read page orientation from builder (fit to width/fit to height)
    // NEMO-10987: TOC closed on accessing the ebook
    // if (window.innerWidth >= 576) {
      // For Tablet and Desktop devices only
      // this.toggleSidebar.emit();
      // this.fitToWidth.emit();
    // }
  }

  jumptoPanel() {
        
    this.isPanelOpen = !this.isPanelOpen;

    if(this.isPanelOpen) {
      this.addJumpToPagePanelKeyboardEventListeners();
    } else {
      this.removeJumpToPagePanelKeyboardEventListeners();
    }

    this.jumpToString = "";
    for(let i=0; i<this.totalPages.length; i++){
        this.jumpToString += "-";
    }
    this.panelError = false;
    this.pageDoesNotExistError = false;
  }

  /**
   * Handles the keydown event for the home button.
   * 
   * @param event - The keyboard event triggered by the user.
   * 
   * If the "Tab" key is pressed along with the "Shift" key, the tabbing order map is reset with current index = final index and a timer is set to 'timer1'.
   * If only the "Tab" key is pressed, the tabbing order map is reset with current index = start index and a timer is set to 'timer2'.
   */
  public homeBtnKeyDnHandler(event){
    if(event.key == "Tab" && event.shiftKey){
      this.tabbingOrderService.resetMap(true);
      this.tabbingOrderService.setTimerMap('timer1');
    }
    else if(event.key == "Tab"){
      this.tabbingOrderService.resetMap();
      this.tabbingOrderService.setTimerMap('timer2');
    }
  }

  /**
   * Handles the keydown event for the Save button.
   * 
   * @param event - The keyboard event triggered by the user.
   * 
   * If the "Tab" key is pressed along with the "Shift" key, tabbing of timer is set to 'timer1'.
   * If only the "Tab" key is pressed,tabbing of timer is set to 'timer2'.
   */
  public saveBtnKeyDnHandler(event){
    if(event.key == "Tab" && event.shiftKey){
      this.tabbingOrderService.setTimerMap('timer2');
    }
    else if(event.key == "Tab"){
      this.tabbingOrderService.setTimerMap('timer1');
    }
  } 
  
  isJumpToStringEmpty(str) {
    for(let i=0; i<str.length; i++) {
        if(str[i] != "-") {
            return false;
        } 
    }
    return true;
  }

  enterPageNumber(number, ev) {
    
    if(ev) {
      ev.stopPropagation();
    }

    // if there is an existing panel error or trying to start string with 0, user will not be allowed to enter any new number
    if(this.panelError || (!number && this.isJumpToStringEmpty(this.jumpToString))) {
      return; 
    } else {
      this.panelError = false;

      if(this.jumpToString.indexOf('-') > -1) {
          this.jumpToString = this.jumpToString.slice(1, this.jumpToString.length) + number;
      }

      if(Number(this.jumpToString) > Number(this.totalPages)) {
        this.panelError = true;
        this.ref.detectChanges();
      }

      this.pageDoesNotExistError = false;
      if(!this.isJumpToStringEmpty(this.jumpToString) && !this.imgBookHelperService.isPageLabelValid(Number(this.jumpToString.split('-').join("")))) {
        this.pageDoesNotExistError = true;
      }
      
      // internal fix for jump to page
      // if user input page numbers length is equals to total page numbers length
      if(this.jumpToString[0]!= '-' && this.jumpToString.length == this.totalPages.length){
        this.isPageLength = true;
      }

      this.checkIfPanelIsCurrentPage();
    }
  }

  deleteNumber(event?) {

    if(event) {
      event.stopPropagation();
    }
    this.jumpToString = '-' + this.jumpToString.slice(0,this.jumpToString.length-1);
    this.panelError = false;
    this.isPageLength = false;
    this.pageDoesNotExistError = false;
    if(!this.isJumpToStringEmpty(this.jumpToString) && !this.imgBookHelperService.isPageLabelValid(Number(this.jumpToString.split('-').join("")))) {
      this.pageDoesNotExistError = true;
    }
    this.checkIfPanelIsCurrentPage();
  }

  jumpToPage() {

      // #243 : NEMO-3629: [FoC] Spotlight - If user shift the page via Jump to Page then Spotlight box appear on Navigated page
      // this.jumpToPagePanelEventHandler.emit({"closeAllSelectionBoxes":true});

      if(this.panelOnSamePage) return;
      this.isPageLength = false;

      this.jumpToString = this.jumpToString.split('-').join('');

      if(!this.jumpToString) {
        this.isPanelOpen = false; // for empty string
        this.removeJumpToPagePanelKeyboardEventListeners();
      } else {
          this.jumpToString = this.jumpToString.split('-').join('');  
          // eleminate leading 0s from page string.
          this.jumpToString = parseInt(this.jumpToString);
          this.jumpToPagePanelEventHandler.emit({"openPage":true, "pageLabel": this.jumpToString});  
          this.jumpToString = "";
          for(let i=0; i<this.totalPages.length; i++){
              this.jumpToString += "-"
          }
      }
  }

  checkIfPanelIsCurrentPage() {
    this.goDisabled = false;
    let currentPage = this.jumpToString.split("-").join("");
    if(this.firstCurrentPage) {
      this.goDisabled = currentPage === this.firstCurrentPage ||  currentPage === this.secondCurrentPage;
      this.panelOnSamePage = this.jumpToString === this.firstCurrentPage ||  this.jumpToString === this.secondCurrentPage;
    }
    return this.panelOnSamePage;
  }

  closeJumpToPanel() {
    this.isPanelOpen = false;  
    this.removeJumpToPagePanelKeyboardEventListeners();  
  }

  addJumpToPagePanelKeyboardEventListeners() {
    this.isPageLength = false;
    document.addEventListener('keydown', this.jumpToPageHandler);
  }

  removeJumpToPagePanelKeyboardEventListeners() {
    document.removeEventListener('keydown', this.jumpToPageHandler);
    this.panelOnSamePage = false;
  }

  jumpToPagePanelKeyboardEventListenerHandler(event) {
    
    let parentIsPanel = this.isParentPanel(document.activeElement);
    let emptyJumpToString = "";
    for(let i=0; i<this.totalPages.length; i++){
        emptyJumpToString += "-"
    }

    // let tab use default events as it controls focus.
    if( !(event.keyCode == 9 || (event.keyCode == 13 && parentIsPanel)) ) {
        // prevent the keyboard triggering any event.
        event.preventDefault();
        event.stopPropagation();
        // event.stopImmediatePropagation();
    }

    switch(event.keyCode) {

      // backspace
      case 8 : this.deleteNumber(event); break;

      // numpad enter and normal enter
      case 13 : if(this.panelError) break; 
                if(parentIsPanel) break;
                if(this.pageDoesNotExistError) break;
                this.jumpToPage(); 
                this.ref.detectChanges(); 
                $("#jump-to-page-panel-toolbar").trigger($.Event('hide.bs.dropdown', {closeDropdownKeyboard: true}));
                if($("#jump-to-page-panel-toolbar")?.find(".dropdown-menu").hasClass("show")) {
                  $('#jump-to-page-panel-toolbar').dropdown('toggle');
                }
                break;
                
      // normal escape
      case 27 : this.jumpToString = ""; 
                this.isPanelOpen = false; 
                this.removeJumpToPagePanelKeyboardEventListeners();
                this.ref.detectChanges(); 
                $("#jump-to-page-panel-toolbar").trigger($.Event('hide.bs.dropdown', {closeDropdownKeyboard: true}));
                $('#jump-to-page-panel-toolbar').dropdown('toggle');
                break;

      // 48 - 57 numbers on special characters row.
      // 96 - 105 numpad numbers.
      default : if( (event.keyCode > 47 && event.keyCode < 58) || (event.keyCode > 95 && event.keyCode < 106) ) {

        // return if the key was modified and special characters were added.
        if( event.metaKey || event.shiftKey) {
            break;
        }

        // return if 0 is the starting number of empty string.
        if( (event.keyCode == 48 || event.keyCode == 96) && this.jumpToString == emptyJumpToString) {
            break;
        }
          
        this.enterPageNumber(event.key, event);
      }
      break;

    }
  }

  isParentPanel(element) {
    let keypadWrapper = document.querySelector('.keypad-wrapper');
    if(element && element.parentNode == keypadWrapper) {
        return true;
    }
    return false;
  }


  onSidebarToggle(options) {

    // everything handled via new buttons and css. not required at the moment
    // TODO : remove the commented code when the story passes all checks.
    
    
    // let desktopDiv:any = document.querySelector(".toolbar-container").querySelector(".desktop");
    // let leftMenu = desktopDiv.querySelector(".group-1");     
    // let mainMenu = desktopDiv.querySelector(".group-2");     
    // let rightMenu = desktopDiv.querySelector(".group-3");

    // let toolbarStatusButton = desktopDiv.querySelector('.toolbar-status-container-parent');
    // let verticalDivider = desktopDiv.querySelector('.vertical-divider');

    // // let toolBarEbooks = desktopDiv.querySelector(".dropup");
    // if(options && $(window).width() >= 992 && $(window).width() < 1200) {   
    //   if(options["sidebar-active"]) {
    //     leftMenu.style.width = "30%";

    //     leftMenu.style["border-radius"] = "unset";
    //     leftMenu.style["justify-content"] = "space-around";

    //     mainMenu.style.width = "60%";
    //     if(options["sidebar-position"] == "right")
    //       mainMenu.style.left = "40%";
    //     else
    //       mainMenu.style.left = "60%";

        
    //     mainMenu.style["border-radius"] = "unset";

    //     rightMenu.style.width = "10%";
        

    //     rightMenu.style["border-radius"] = "unset";
    //     rightMenu.style.display = "flex";
    //     rightMenu.style["justify-content"] = "center";

    //     toolbarStatusButton.classList.add('hide');
    //     verticalDivider.classList.add('hide');

    //     // toolBarEbooks.classList.add('hide');
    //     // mainMenu.classList.add('reposition');
    //     // leftMenu.classList.add('reposition');

    //   } else {
    //       leftMenu.removeAttribute("style"); 
    //       rightMenu.removeAttribute("style");
    //       mainMenu.removeAttribute("style"); 
    //       toolbarStatusButton.classList.remove('hide');
    //       verticalDivider.classList.remove('hide');
    //       // toolBarEbooks.classList.remove('hide');
    //       // mainMenu.classList.remove('reposition');
    //       // leftMenu.classList.remove('reposition');

    //   }  
    // } 
    // else if (options["sidebar-active"] &&  $(window).width() < 1422){
    //   // toolBarEbooks.classList.add('hide');
    //   // mainMenu.classList.add('reposition');
    //   // leftMenu.classList.add('reposition');
    // }
    // else {
    //   leftMenu.removeAttribute("style"); 
    //   rightMenu.removeAttribute("style");
    //   mainMenu.removeAttribute("style"); 
    //   toolbarStatusButton.classList.remove('hide');
    //   verticalDivider.classList.remove('hide');
    //   // toolBarEbooks.classList.remove('hide');
    //   // mainMenu.classList.remove('reposition');
    //   // leftMenu.classList.remove('reposition');

    // } 

  }

  toggleStatusActive() {
    this.config.isStatusActive = true;
    this.ref.detectChanges();
  }

  toggleStatusInActive() {
    this.config.isStatusActive = false;
    this.ref.detectChanges();
  }

  studentBookEvents(options) {
    
    if(options.onSidebarToggle) {
      this.isPanelOpen = false;
      this.removeJumpToPagePanelKeyboardEventListeners();
    }

    if(options.onPageNavigate) {
      this.isDrawingLoaded = false;
      this.isPageLoaded = false;
      this.isPanelOpen = false;
      this.removeJumpToPagePanelKeyboardEventListeners();
      if(options.page) {
        this.firstCurrentPage = options.page.label;
        this.secondCurrentPage = "";
      }
      //NEMO-8172 ([eReader] Numpad remains displayed but disabled after jumping into another page via hotspot)
      if($("#jump-to-page-panel-toolbar").find(".dropdown-menu") && $("#jump-to-page-panel-toolbar").find(".dropdown-menu").hasClass("show")) {
        $("#jump-to-page-panel-toolbar").find(".dropdown-menu").removeClass("show");
        $("#jump-to-page-panel-toolbar").dropdown('dispose');
      }
    }

    // if(options.onBookDataLoad) {
    //   this.totalPages = options.totalPages;
    //   this.jumpToString = "";
    //   for(let i=0; i<this.totalPages.length; i++) {
    //       this.jumpToString += "-";
    //   }
    // }

    if(options.onPageLoad) {
      this.isPageLoaded = true;
      this.panelError = false;
      this.jumpToString = "";
      for (let i = 0; i < this.totalPages.length; i++) {
        this.jumpToString += "-";
      }
      this.totalPages = options.totalPages;
      this.firstCurrentPage = options.page && options.page[0].label;
      this.secondCurrentPage = options.page && options.page[1] && options.page[1].label;
      $('#pageNavigateButton').prop("disabled", false);
    }

    if(options.onToggleImgbookLayout) {
      this.isPanelOpen = false;
    }

    if(options.onLastVisitedPage) {
      this.jumpToString = options.previousPageLabel;
    }

    if(options.onDrawingLoaded) {
      if(!options.status && options.status != "error") {
        this.isDrawingLoaded = true;
      }
    }

    if(options.onToggleBook) {
      this.isDrawingLoaded = false;
      this.isPageLoaded = false;
      this.isPanelOpen = false;
      this.removeJumpToPagePanelKeyboardEventListeners();
      if(this.config.showSelectionBoxMenu)
        this.toggleSelectionBoxMenu.emit(false);
    }

    if(options.jumpToPageEventFromNotes) {
      this.isDrawingLoaded = false;
      this.isPageLoaded = false;
      this.isPanelOpen = false;
      this.removeJumpToPagePanelKeyboardEventListeners();
    }
  }

  getLastActiveFeature() {
    return this.lastActiveFeature;
  }

  setLastActiveFeature(featureName) {
    this.lastActiveFeature = featureName;
  }

  async navigateToDashboard(event){
    event.stopPropagation();
    this.loaderService.showOverlayLoader();
    await this.xAPIHelperService.flushStateAndStatement();
    this.navigateToUserDashboard.emit();
    window.sessionStorage.removeItem('showPDZTipModal');
  }

  /**
   * 
   * @param book method to check if the book is to be shown enabled in the toc dopdown
   * */
  isDDBookEnabled(book) {
    if (environment.isDesktopApp) {
      if (this.isOnline) {
        return true;
      } else {
        return this.downloadHelperService.isBookDownloaded(book.bookCode);
      }
    } else {
      return true;
    }
  }

  ngOnDestroy(): void {
    this.networkStatusSubscription.unsubscribe();
    this.removeJumpToPagePanelKeyboardEventListeners();  
    $(".foc-container").off('hide.bs.dropdown', '#jump-to-page-panel-toolbar');
    $(".foc-container").off('hide.bs.dropdown', '#jump-to-page-panel')
    $('#jump-to-page-panel-toolbar').off('keydown');
    
  }

  //to check if any book is downloaded in the given bundle or not
  anyBookDownloaded(){
    for(let book of this.ebookData){
      if(this.downloadHelperService.isBookDownloaded(book.bookCode) && this.currentBook!=book.bookCode){
        return true;
      }
    }
    return false;
  }


  /**
   * Toggles the timer button and resets the tabbing order for the timer button.
   * 
   * This method emits the `toggleTimer` event, resets the tab index for the timer button,
   * and updates the `timer` and `timerCrossBtn` to timer2 and timer2CrossBtn respectively.
   * 
   */
  toggleTimerBtn(){
    this.toggleTimer.emit()
    this.tabbingOrderService.resetTabIndex('timerBtn');
    this.tabbingOrderService.timer = this.tabbingOrderService.flattenedTabOrderMap.timer2;
    this.tabbingOrderService.timerCrossBtn = this.tabbingOrderService.flattenedTabOrderMap.timer2CrossBtn;
    
    setTimeout(() => {
      document.getElementById('timerCrossBtn').focus();
    }, 0);
  }
}